import React, { useState, useEffect } from 'react'
import { TOAST_OPTIONS, EXPLORER } from '../../constants'

//UTILS
import { isMobile, useMobileOrientation } from 'react-device-detect'
import TokenService from "../../services/token_services"
import UserService from '../../services/user_services'

//VISUALS
import LOGO_BLACK from '../../assets/images/logo_black.png'
import TOKEN_BLACK from '../../assets/images/token_black.png'
import BANKINGWEB3 from '../../assets/images/banking_web3.png'

//COMPONENTS
import Menu from '../../components/menu'
import BoardHeader from '../../components/boardheader'
import Button from '../../components/button'
import ReferralPopup from '../../components/referral-popup'
import { ToastContainer, toast } from 'react-toastify'
import { ThreeDots } from 'react-loader-spinner'

//TRANSLATION
import { useTranslation } from 'react-i18next'

const Dashboard = () => {
    const { t } = useTranslation()
    const [profile, setProfile] = useState({})
    const [balance, setBalance] = useState("-")
    const [caam, setCaam] = useState("-")
    const [tokenClaims, setTokenClaims] = useState([])
    const [claiming, onChangeClaiming] = useState(false)
    const [displayPurchase, setDisplayPurchase] = useState(false)
    const [amount, setAmount] = useState("")
    const [loading, onChangeLoading] = useState(null)
    const [trigger, onChangeTrigger] = useState(false)
    const [banking, setBanking] = useState({})
    const [reference, setReference] = useState(null)
    const [price, setPrice] = useState(null)
    const [orders, setOrders] = useState([])
    const [kycDetails, setKYCdetails] = useState({})
    const [copied, setCopied] = useState(null)
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const { isLandscape } = useMobileOrientation()

    const togglePurchase = () => {
        if (kycDetails && kycDetails.kyc_status === "APPROVED")
            setDisplayPurchase(true);
        else {
            toast.info(t('dashboard.approved_kyc'), TOAST_OPTIONS);
            if (!kycDetails || kycDetails.kyc_status !== "REVIEW")
                window.open(kycDetails.kyc_url)
        }
    }

    const copyClipboard = (key, value) => {
        setCopied(key)
        navigator.clipboard.writeText(value)
        setTimeout(() => {
            setCopied(null)
        }, 2000)
    }

    const handleJoinMeClick = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    const loadInfo = async () => {
        const data = TokenService.getUser()
        setProfile(data.account)
        const acc = await UserService.getAccountDetails()
        let tokens = {}
        for (let token of acc.wallet.tokens) {
            tokens[token.metadata.symbol] = token
        }
        setBalance(tokens["CaaEURO"].balance)
        setCaam(tokens["CAAM"].balance)
        setTokenClaims(acc.token_claims.to_claim)
        const purchases = await UserService.listOrders()
        setOrders(purchases)
        const details = await UserService.detailsKYC()
        setKYCdetails(details)
        onChangeTrigger(true)
    }

    useEffect(() => {
        loadInfo()
        // eslint-disable-next-line
    }, [])

    const claimFunds = async (claim_uuid) => {
        if (kycDetails && kycDetails.kyc_status === "APPROVED") {
            if (claiming)
                toast.warn(t('dashboard.wait_claim'), TOAST_OPTIONS)
            else {
                onChangeClaiming(true)
                try {
                    const resp = await UserService.claim([claim_uuid])
                    if (resp.status && resp.transactions[claim_uuid]) {
                        toast.success(`${t('dashboard.funds_claimed')} ${resp.transactions[claim_uuid].tx_hash.substring(0, 10)}...${resp.transactions[claim_uuid].tx_hash.substring(resp.transactions[claim_uuid].tx_hash.length - 10, resp.transactions[claim_uuid].tx_hash.length - 1)}`, TOAST_OPTIONS)
                        setTimeout(async () => {
                            await loadInfo()
                            onChangeClaiming(false)
                        }, 2500)
                    } else {
                        toast.error(resp.message, TOAST_OPTIONS)
                        onChangeClaiming(false)
                    }
                } catch (e) {
                    console.log(e.response.data)
                    toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS)
                    onChangeClaiming(false)
                }
            }
        }
        else {
            toast.info(t('dashboard.claim_kyc'), TOAST_OPTIONS);
            if (!kycDetails || kycDetails.kyc_status !== "REVIEW")
                window.open(kycDetails.kyc_url)
        }
    }

    const depositOrder = async () => {
        if (!amount || amount === "-" || (parseInt(amount) < 50))
            toast.error(t('transfer.invalid_amount') + ' Min. 50 €', TOAST_OPTIONS)
        else {
            onChangeLoading(true)
            if (window.confirm(t('dashboard.confirm_deposit'))) {
                try {
                    const resp = await UserService.createOrder(parseInt(amount))
                    if (resp.status) {
                        setBanking(resp.bank_account)
                        setReference(resp.reference)
                        setPrice(resp.price_eur)
                        toast.success(t('dashboard.order_created'), TOAST_OPTIONS)
                    } else
                        toast.error(resp.message, TOAST_OPTIONS)
                } catch (e) {
                    console.log(e.response.data)
                    toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS)
                }
            }
            onChangeLoading(false)
        }
    }

    const formatDate = (value) => value ? new Date(value).toLocaleDateString() : "-"

    const shortHash = (value) => {
        if (!value) return ""
        if (value.length <= 22) return value
        return `${value.substring(0, 10)}...${value.substring(value.length - 8)}`
    }

    const isKycApproved = kycDetails && kycDetails.kyc_status === "APPROVED"
    const shouldShowKycAction = !kycDetails.kyc_status || ['STARTED', 'REJECTED', 'EXPIRED', 'WAITING'].includes(kycDetails.kyc_status)
    const kycStatusValue = kycDetails.kyc_status || t('dashboard.no_kyc')
    const kycStatusClass = !kycDetails.kyc_status ? 'warning' : isKycApproved ? 'success' : 'primary'

    return (
        <div className="dashboard">
            <Menu />
            <div className="right_board">
                <BoardHeader title={t('dashboard.my_account')} />
                {!reference && !isMobile && <img src={BANKINGWEB3} className="visual" alt="Digital banking" />}
                <div className="content">
                    {trigger &&
                        <div className="identity_card">
                            <div className="identity_row">
                                <span className="identity_label">{t('dashboard.account_number')}</span>
                                <span className="identity_value">{profile.public_address || '-'}</span>
                            </div>
                            <div className="identity_row">
                                <span className="identity_label">{t('dashboard.kyc_status')}</span>
                                <span className={`identity_status ${kycStatusClass}`}>{kycStatusValue}</span>
                            </div>
                        </div>
                    }
                    {trigger &&
                        <div className="balances_section">
                            <div className="balances_grid">
                                <div className="balance_card">
                                    <span className="balance_label">CAAM</span>
                                    <div className="balance_value_line">
                                        <span className="balance">{caam}</span>
                                        <img src={TOKEN_BLACK} className="currency" alt="Caâm logo" />
                                    </div>
                                    {!reference && !displayPurchase &&
                                        <div className="balance_actions">
                                            <Button title={t('dashboard.purchase_caam')} framed={!isKycApproved} click={() => window.location.href = '/purchase'} />
                                        </div>
                                    }
                                </div>

                                <div className="balance_card">
                                    <span className="balance_label">CaaEURO</span>
                                    <div className="balance_value_line">
                                        <span className="balance">{balance}</span>
                                        <img src={LOGO_BLACK} className="currency" alt="CaaEuro logo" />
                                    </div>
                                    {!reference && !displayPurchase &&
                                        <div className="balance_actions">
                                            <Button title={t('dashboard.purchase_caaeuro')} framed={!isKycApproved} click={togglePurchase} />
                                        </div>
                                    }
                                </div>
                            </div>

                            {!reference && !displayPurchase && shouldShowKycAction &&
                                <div className="balance_cta_row">
                                    <Button title={t('dashboard.process_kyc')} framed={false} click={() => { window.open(kycDetails.kyc_url) }} />
                                </div>
                            }
                        </div>
                    }

                    {!reference && displayPurchase &&
                        <React.Fragment>
                            <h2 className="mt-50">{t('dashboard.purchase_by_transfer')}</h2>
                            <label>{t('dashboard.amount_to_purchase')}</label>
                            <div className="relative display-inline-block">
                                <input type="number" className="semi" placeholder={"CâaEuro amount"} min="0" step="1" onChange={(e) => setAmount(e.target.value)} value={amount} />
                                <img src={LOGO_BLACK} className="caaeuro" alt="Logo CâaEuro" />
                            </div>
                            {!loading &&
                                <div className="relative display-inline-block mobile_simple_block">
                                    <Button title={t('dashboard.set_order')} click={depositOrder} />
                                    <Button title={t('dashboard.cancel')} framed={true} click={() => setDisplayPurchase(false)} />
                                </div>}
                            <div className="relative display-inline-block mobile_simple_block ml-20">
                                <ThreeDots visible={loading} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                            </div>
                        </React.Fragment>
                    }
                    {reference &&
                        <React.Fragment>
                            <h2 className="mt-50">{t('dashboard.order_created_short')}</h2>
                            <label className="ml-0">
                                <small>{t('dashboard.order_mail')}</small>
                            </label>
                            <label className="ml-0">
                                {t('dashboard.order_complete1')} <strong>{t('dashboard.order_complete2')}</strong> {t('dashboard.order_complete3')}
                            </label>
                            <table className="receipt_order">
                                <tr>
                                    <td>
                                        <label>{t('dashboard.reference')}</label>
                                    </td>
                                    <td>
                                        <label><h3 className="primary">{reference} <span className="pointer" onClick={() => copyClipboard("ref", reference)}>{copied === "ref" ? "✅" : "📋"}</span></h3></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>{t('dashboard.amount')}</label>
                                    </td>
                                    <td>
                                        <label><h3>{price} € <span className="pointer" onClick={() => copyClipboard("price", price)}>{copied === "price" ? "✅" : "📋"}</span></h3></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>{t('dashboard.acc_number')}</label>
                                    </td>
                                    <td>
                                        <label><h3>{banking.iban} <span className="pointer" onClick={() => copyClipboard("iban", banking.iban)}>{copied === "iban" ? "✅" : "📋"}</span></h3></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>BIC/SWIFT</label>
                                    </td>
                                    <td>
                                        <label><h3>{banking.bic_swift} <span className="pointer" onClick={() => copyClipboard("bic", banking.bic_swift)}>{copied === "bic" ? "✅" : "📋"}</span></h3></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>{t('dashboard.bank_name')}</label>
                                    </td>
                                    <td>
                                        <label><h3>{banking.bank_name} <span className="pointer" onClick={() => copyClipboard("bank_name", banking.bank_name)}>{copied === "bank_name" ? "✅" : "📋"}</span></h3></label>
                                    </td>
                                </tr>
                            </table>
                            <hr />
                        </React.Fragment>
                    }
                    {!loading && orders.length > 0 &&
                        <div className="data_section">
                            <h2 className="mt-50">{t('dashboard.purchase')}</h2>
                            <div className="dashboard_table_wrap">
                                <table className="dashboard_table">
                                    <thead>
                                        <tr>
                                            <th>REF</th>
                                            <th>{t('dashboard.created')}</th>
                                            <th>{t('dashboard.amount')}</th>
                                            <th>{t('dashboard.funds_sent')}</th>
                                            <th>Tx</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders.map(op =>
                                            <tr key={op.user_purchase_uuid}>
                                                <td>
                                                    <span className="cell_label">REF</span>
                                                    <strong>{op.reference}</strong>
                                                </td>
                                                <td>
                                                    <span className="cell_label">{t('dashboard.created')}</span>
                                                    {formatDate(op.created_date)}
                                                </td>
                                                <td>
                                                    <span className="cell_label">{t('dashboard.amount')}</span>
                                                    {op.total_price_eur} € / {op.nb_token} CaâEuro
                                                </td>
                                                <td>
                                                    <span className="cell_label">{t('dashboard.funds_sent')}</span>
                                                    {op.payment_date ? formatDate(op.payment_date) : <span className="status_badge pending">{t('dashboard.awaiting_transfer')}</span>}
                                                </td>
                                                <td>
                                                    <span className="cell_label">Tx</span>
                                                    {op.tx_hash ?
                                                        <span className="tx_link" onClick={() => window.open(`${EXPLORER}/tx/${op.tx_hash}`)}>{shortHash(op.tx_hash)}</span>
                                                        :
                                                        <span className="status_badge">-</span>
                                                    }
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                    {tokenClaims.length > 0 &&
                        <React.Fragment>
                            <div className="data_section">
                                <h2 className="mt-50">
                                    {t('dashboard.pending_claims')}
                                </h2>
                                <ThreeDots visible={claiming} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                                {!claiming && <div className="dashboard_table_wrap">
                                    <table className="dashboard_table claim_table">
                                        <thead>
                                            <tr>
                                                <th>{t('dashboard.received_on')}</th>
                                                <th>{t('dashboard.amount')}</th>
                                                <th>{t('dashboard.press_to_claim')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tokenClaims.map(claim =>
                                                <tr key={claim.token_claim_uuid}>
                                                    <td>
                                                        <span className="cell_label">{t('dashboard.received_on')}</span>
                                                        {formatDate(claim.created_date)}
                                                    </td>
                                                    <td>
                                                        <span className="cell_label">{t('dashboard.amount')}</span>
                                                        <span className="claim_amount">{claim.nb_token} <img src={LOGO_BLACK} className="balance_logo" alt="Logo CâaEuro" /></span>
                                                    </td>
                                                    <td>
                                                        <span className="cell_label">{t('dashboard.press_to_claim')}</span>
                                                        <button className="claim_action_btn" onClick={() => claimFunds(claim.token_claim_uuid)}>
                                                            {t('dashboard.press_to_claim')}
                                                        </button>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </React.Fragment>
                    }
                    {isMobile && !isLandscape &&
                        <div className="share share_mobile">
                            <p className="center">
                                {t('dashboard.send_link')}
                                <br />
                                {t('dashboard.join_you')}
                            </p>
                            <button className="action" onClick={handleJoinMeClick}>{t('dashboard.share')}</button>
                        </div>
                    }
                </div>
            </div>
            <ReferralPopup isOpen={isPopupOpen} onClose={closePopup} />
            <ToastContainer />
        </div>
    )
}

export default Dashboard